import React from 'react';

const TermsModal = ({ onClose }) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header" style={{ position: "sticky", top: 0, left: 0 }}>
          <div className="modal-close" onClick={onClose}>
            <div className="close-button"></div>
          </div>
          <p className="terms-of-use-modal-header">脳の健康3分チェック 利用規約及び個人情報の取扱いについて</p>
        </div>
          <div className="modal-body">
            <p>
              第1章　当社サービスの利用方法<br></br>
              <br></br>
              第1条　（適用）<br></br>
              1. この利用規約（以下「本規約」といいます。）は、株式会社CogSmart（以下「当社」といいます。）が提供する、次に掲げるサービス（「脳の健康3分チェック」その他当社指定の名称をつけることがあります。以下、総称して「本サービス」といいます。）の利用に対して、適用されます。<br></br>
              (1) 認知機能テストの受検サービス<br></br>
              (2) 上記(1)のサービスと一連のサービス、又は関連し若しくは付随するサービスとして、当社が提供するもの<br></br>
              2. 本サービスを利用する個人（以下「ユーザー」といいます。）は本規約に同意のうえ、本サービスをご利用いただくことができます。なお、本規約への同意手続きに代えて、実際に本サービスをご利用いただく場合にも、本規約に同意いただいたものとみなします。<br></br>
              3. 当社が本サービス上に掲載又は提示・提供する諸注意等が存在する場合、その形式に拘らず、当該諸注意等は本規約の一部を構成するものとします。<br></br>
              <br></br>
              第2条　（ユーザーの責任）<br></br>
              1. ユーザーは、自らの意思及び責任において、本サービスの利用又は当社への登録を行うものとします。<br></br>
              2. 本サービスでは、インターネット接続環境のあるPC、タブレット端末又はスマートフォン端末をご用意いただく必要があります。ユーザーは、自己の費用と責任において、本サービスの提供を受けるために必要なインターネット接続環境のある上記機器を用意するものとします。<br></br>
              3. 本サービスを受検するにあたり、ユーザーによっては過度のストレスを伴うものや、気分を悪くされるものを含む場合があります。この場合、ユーザーは、回答をしない、一度テストを中断して体調が回復したら再度受検する、回答を放棄して全てのテストを完了する等の対応が可能です。但し、これらの対応をした場合、本サービスを正確又は適切に提供できなくなる場合があります。当該対応によりユーザーに発生した不利益又は損害について、当社の責めに帰すべき事由がある場合を除き、当社は責任を負わないものとします。<br></br>
              <br></br>
              第2章　個人情報及びデータの取扱い<br></br>
              <br></br>
              第3条　（個人情報の取扱い）<br></br>
              1. 当社は、ユーザーの個人情報を、個人情報保護法その他の関係法令及び個人情報保護委員会の定めるガイドライン等並びに当社の個人情報保護方針（<a href="https://www.cogsmartglobal.com/Terms-and-conditions/pp" target="_blank" rel="noopener noreferrer">https://www.cogsmartglobal.com/Terms-and-conditions/pp</a>）、「個人情報に関する公表事項」（<a href="https://www.cogsmartglobal.com/Terms-and-conditions/parpi" target="_blank" rel="noopener noreferrer">https://www.cogsmartglobal.com/Terms-and-conditions/parpi</a>）及び本規約に従い、適法かつ適正に取り扱います。<br></br>
              2. ユーザーが本サービスを利用するにあたり、当社は次の情報の一部又は全てを取得する場合があります（以下「個人情報」といいます。）。<br></br>
              ・氏名・ふりがな<br></br>
              ・性別<br></br>
              ・生年月日<br></br>
              ・メールアドレス<br></br>
              ・本サービスの受検結果<br></br>
              3. 当社は前項により取得したユーザーの個人情報を以下の利用目的にのみ使用し、その他の目的では使用いたしません。<br></br>
              ①	ユーザーご本人へ本サービスを提供するため（前項の生年月日から算出した年齢を用いて受検結果を評価することを含みます。）<br></br>
              ②	ユーザーからのご質問・ご相談・お問い合わせ等に対応するため<br></br>
              ③	ユーザーからご意見・ご感想をいただくため<br></br>
              ④	認知症その他脳疾患予防や脳健康の維持・向上に関する、当社商品・サービスの改善若しくは新商品・新サービスの開発（例えば、認知症予防を促す認知症保険商品や、生活習慣改善促進サービスなど、認知症その他脳疾患予防や脳健康の維持・向上に関する新商品・新サービスの開発を含みます。）、学術研究又はデータ利活用ビジネスへの活用のため<br></br>
              ⑤	会計監査その他法令に基づく監査の確認作業のため<br></br>
              ⑥	その他上記に掲げる利用目的に付帯・関連する事項のため<br></br>
              4. 当社は、取り扱う個人データの漏洩、滅失又は毀損の防止その他の個人データの安全管理のために必要かつ適切な措置を講じます。<br></br>
              <br></br>
              第4条　（第三者提供及び委託）<br></br>
              当社は、個人情報保護法その他の法令に基づく場合を除き、あらかじめユーザーの同意を得ることなく、ユーザーの個人データを第三者に提供しません。また、当社は、利用目的の達成に必要な範囲内で、個人データの取扱いの全部又は一部を外部に委託することがあり、この場合、委託先に対し必要かつ適切な監督を行います。<br></br>
              <br></br>
              第5条　（個人情報の提供の任意性）<br></br>
              当社への個人情報の提供及びこれに関する同意は、任意によるものです。但し、本サービスの提供に必要となる情報をご提供いただけない場合には、本サービスをご利用いただけません。<br></br>
              <br></br>
              第6条　（個人情報の保持）<br></br>
              当社は、利用目的に照らし必要がなくなったときは、ユーザーの個人情報を遅滞なく消去します。但し、適用法令等を遵守するために保持しなければならない場合、未解決の請求又は苦情に対応する場合など、正当な必要性がある場合に限り、当該個人情報を保持することがあります。<br></br>
              <br></br>
              第7条　（利用目的の変更）<br></br>
              当社は、利用目的の変更を行った場合には、変更の理由及び変更後の利用目的について、当社所定の方法によりユーザーに通知し、又は当社ウェブサイト上に公表するものとします。<br></br>
              <br></br>
              第8条　（保有個人データ等の開示、訂正等、利用停止等）<br></br>
              ①	当社は、ユーザーから、個人情報保護法の定めに基づき保有個人データ若しくは第三者提供記録の開示又は保有個人データの利用目的の通知を求められたときは、ユーザーご本人からの請求であることを確認した上で、遅滞なく開示又は通知いたします。但し、個人情報保護法その他の法令により、当社が開示又は通知する義務を負わない場合はこの限りではありません。<br></br>
              ②	当社は、ユーザーから、個人情報保護法の定めに基づき保有個人データの内容が事実でないとして当該保有個人データの内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められたときは、ユーザーご本人からの請求であることを確認した上で、遅滞なく必要な調査を行い、その結果に基づき、訂正等を行います。但し、個人情報保護法その他の法令により、当社が訂正等を行う義務を負わない場合はこの限りではありません。<br></br>
              ③	当社は、ユーザーから、個人情報保護法の定めに基づき、保有個人データの利用停止、消去又は第三者提供の停止（以下「利用停止等」といいます。）を求められたときは、ユーザーご本人からの請求であることを確認した上で、遅滞なく利用停止等を行います。但し、個人情報保護法その他の法令により、当社が利用停止等を行う義務を負わない場合はこの限りではありません。<br></br>
              ④	前３号に定めるお求めをご希望いただく場合は、第9条に記載の【お問い合わせ窓口】宛までご連絡ください。<br></br>
              <br></br>
              第9条　（お問い合わせ窓口）<br></br>
              当社では、個人情報を適切に保護するための管理者を下記お問い合わせ窓口の個人情報保護管理者が担当しております。個人情報管理に関するお問い合わせや照会、訂正又は削除等の依頼は、下記までご連絡ください。<br></br>
              【お問い合わせ窓口】<br></br>
              株式会社CogSmart 個人情報お問い合わせ窓口<br></br>
              個人情報保護管理者 代表取締役　樋口　彰<br></br>
              〒103-0023　東京都中央区日本橋本町三丁目11番5号<br></br>
              Eメール: <a href="mailto:support@cogsmart-global.com">support@cogsmart-global.com</a><br></br>
              <br></br>
              第10条　（Cookie、広告識別子（IDFA/AAID）、Googleアナリティクス）<br></br>
              ①	当社では、サービスのご利用状況を把握し、サービスの利便性を向上するため、またユーザーに適した広告配信等のために、Cookie、広告識別子（IDFA/AAID※）を使用し、又は類似の技術を利用する場合があります。これらの情報に特定の個人を識別する情報は含まれていません。<br></br>
              ②	当社は、サービスのご利用状況を把握し、サービスの利便性を向上するために、Google社が提供するGoogle Analyticsを利用する場合があります。Google AnalyticsはCookie等を利用して、特定の個人を識別する情報を含まないかたちで閲覧履歴を収集、分析し、当社はその結果を受け取り、ユーザー（当社ウェブサイトの訪問者を含みます。）の利用状況を把握することで、サービスの開発、改善等に利用する場合があります。<br></br>
              Google Analyticsの無効設定は、以下のGoogle Analyticsオプトアウトアドオンからブラウザのアドオン設定を変更することで可能となります。なおGoogle Analyticsによって収集される情報はGoogle社のプライバシーポリシーに基づいて管理されます。<br></br>
              Googleアナリティクス利用規約<br></br>
              <a href="https://www.google.com/analytics/terms/jp.html" target="_blank" rel="noopener noreferrer">https://www.google.com/analytics/terms/jp.html</a><br></br>
              Googleプライバシーポリシー<br></br>
              <a href="https://policies.google.com/privacy?hl=ja" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=ja</a><br></br>
              Google Analyticsオプトアウトアドオン<br></br>
              <a href="https://tools.google.com/dlpage/gaoptout?hl=ja" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout?hl=ja</a><br></br>
              Googleのサービスを使用するサイトやアプリから収集した情報のGoogleによる使用<br></br>
              <a href="https://policies.google.com/technologies/partner-sites?hl=ja" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/partner-sites?hl=ja</a><br></br>
              <br></br>
              ※Cookieとは、ブラウザでウェブサイトを閲覧した際に作成される、利用履歴や入力内容などのデータを一時的に保管しておく仕組みを指します。<br></br>
              IDFA (Identifier for Advertisers)とAAID (Google Advertising ID)は、いずれもスマートフォン端末等ごとに発行される広告配信用のオンライン識別子（広告ID）です。IDFAはApple社がiOS端末向け、AAIDはGoogle社がAndroid端末向けにそれぞれ発行しています。<br></br>
              <br></br>
              第11条　（データの取扱い）<br></br>
              当社は、本サービスの利用に関するデータのすべてをバックアップする義務を負うものではありません。データの消失又は改変によって、ユーザー又は第三者に発生した損害について、当社の責めに帰すべき事由がある場合を除き、当社は責任を負わないものとします。<br></br>
              <br></br>
              第3章　ご留意事項<br></br>
              <br></br>
              第12条　（禁止事項）<br></br>
              ユーザーは、本サービスの利用に際し、以下に掲げる各号の行為を行ってはならないものとします。違反した場合、当社は当該ユーザーへの事前の通知なく、本サービスの提供を停止し、又は登録を削除する等の措置を講じることができるものとします。これにより当該ユーザーに発生した不利益又は損害について、当社の責めに帰すべき事由がある場合を除き、当社は責任を負わないものとします。<br></br>
              (1)当社又は第三者の権利、利益、名誉権、プライバシー権、その他法令上又は契約上の権利を侵害し、又は侵害する恐れのある行為<br></br>
              (2)当社の円滑な業務運営及び本サービスの提供を妨げる、又は妨げる恐れのある行為<br></br>
              (3)当社のサーバー又はネットワークの機能を破壊したり、妨害したりする行為<br></br>
              (4)本サービスを、提供の趣旨に照らして本来のサービス提供の趣旨や目的とは異なる目的で利用する行為<br></br>
              (5)意図的に虚偽又は不正確な情報を登録又は提供する行為（第三者のなりすましを含む。）<br></br>
              (6)第三者の個人情報その他プライバシーに関する情報を、不正に収集、開示又は提供する行為<br></br>
              (7)不正アクセス行為、第三者のアカウントを利用する行為、複数のアカウントを作成し、又は保有する行為、その他これらに類する行為<br></br>
              (8)ID及びパスワードを第三者に使用させ、譲渡し、貸与し、又は名義変更する等の行為<br></br>
              (9)本規約に違反する行為、又は当社が本規約に違反すると判断する行為<br></br>
              (10)その他、当社が不適切と判断する行為<br></br>
              <br></br>
              第13条　（本サービスの変更・停止・終了）<br></br>
              当社は、以下に掲げる各号のいずれかに該当する場合、ユーザーへの事前の通知なく本サービスを変更・停止・終了することができるものとします。これによりユーザーに発生した不利益又は損害について、当社の責めに帰すべき事由がある場合を除き、当社は責任を負わないものとします。<br></br>
              (1)本サービスを提供するためのシステム、インフラ等について、定期的な保守、点検、若しくは更新又は何らかの緊急の必要を要する事態が発生した場合<br></br>
              (2)当社の責に帰さない不可抗力又はその他不測の事態により、本サービスの提供をすることが困難である場合<br></br>
              (3)その他当社が必要と判断する場合<br></br>
              <br></br>
              第14条　（本規約の変更）<br></br>
              当社は、本規約の変更がユーザーの一般の利益に適合するとき、又は本規約の変更が本規約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるときは、民法第548条の4の規定に基づき、ユーザーの個別の同意を要することなく、本規約を変更することができるものとします。この場合、当社は、変更後の本規約の内容及びその効力発生時期を、当該効力発生時期が到来するまでに、当社ウェブサイトへの掲載その他の適切な方法により周知します。<br></br>
              <br></br>
              第15条　（免責事項）<br></br>
              (1) 当社は、本サービスに事実上又は法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。当社は、ユーザーに対して、かかる瑕疵を除去して本サービスを提供する義務を負いません。<br></br>
              (2) 天災地変、戦争、テロ、暴動、法令の制定又は改廃、電力若しくは通信回線の障害、電気通信事業者の役務の提供の中断、当社が法令上及び契約上求められる安全管理措置を講じていたにもかかわらず発生した不正アクセスその他当社の合理的な支配の及ばない事由により、本サービスの利用不能、データの未着又は混乱が生じた場合、当社は、これによりユーザーに生じた損害について責任を負わないものとします。<br></br>
              (3) 当社は、ユーザーによる本サービスの利用に関連してユーザーに対する責任を負う場合には、当社の故意又は重大な過失による場合を除き、ユーザーに現実に生じた通常かつ直接の範囲の損害に限り、これを賠償するものとし、特別な事情から生じた損害（損害の発生を予見し、又は予見し得た場合を含みます。）については、責任を負わないものとします。<br></br>
              <br></br>
              第16条　（知的財産の取扱い）<br></br>
              本サービスの提供に際して、使用又は掲載されている情報、内容、商標、ロゴマーク等に関する著作権、商標権、その他の知的財産又は知的財産権は、特に明記されていない限り、当社に帰属します。当社は、ユーザーが、私的利用その他法律によって明示的に認められる範囲を超えて、これらの一部又は全部を、そのまま又は改変して転用又は複製することを禁止します。<br></br>
              <br></br>
              第17条　（一般法令の適用）<br></br>
              本規約において定めのない事項については、民法又は商法その他関連する法令の定め（例えば、不法行為及び債務不履行に関する定めなどがありますが、これらに限りません。）が適用されます。<br></br>
              <br></br>
              第18条　（管轄裁判所）<br></br>
              本サービス及び本規約に関する一切の紛争、請求等は、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。<br></br>
              <br></br>
              第19条　（準拠法）<br></br>
              本規約の効力、適用、解釈にあたっては、日本法が適用されるものとします。<br></br>
              <br></br>
              2023年3月8日制定<br></br>
              2026年9月29日改定<br></br>
            </p>
        </div>
      </div>
    </>
  );
};

export default TermsModal
